import React from "react";
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "dark" | "light";
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  tone = "dark"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-60" data-mp="3k06srj15o7sz">
      {kicker && <p className={`mb-3 font-display text-sm font-bold uppercase tracking-[0.14em] ${dark ? "text-brand" : "text-brand-dark"}`} data-id="element-61" data-mp="3k29mad1ioj2g">{kicker}</p>}
      <h2 className={`font-display text-[28px] font-extrabold leading-[1.15] sm:text-4xl md:text-[44px] ${dark ? "text-white" : "text-ink-900"}`} data-id="element-62" data-mp="giewvtjwf3pi">{title}</h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`} data-id="element-63" data-mp="6tdig7t04udn">{subtitle}</p>}
    </div>;
}